"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerRegistry = void 0;
exports.parseWrapper = parseWrapper;
exports.serializeWrapper = serializeWrapper;
const common_1 = require("./common");
const Err = __importStar(require("./errors"));
var UnknownRpcMethod = Err.UnknownRpcMethod;
const utils_1 = require("@streamr/utils");
const ProtoCallContext_1 = require("./ProtoCallContext");
const any_1 = require("../generated/google/protobuf/any");
const DEFAULT_TIMEOUT = 1000;
const parseOptions = (options) => {
    return {
        timeout: options.timeout ?? DEFAULT_TIMEOUT
    };
};
const logger = new utils_1.Logger(module);
function parseWrapper(parseFn) {
    try {
        return parseFn();
    }
    catch (err) {
        throw new Err.FailedToParse(`Could not parse binary to JSON-object`, err);
    }
}
function serializeWrapper(serializerFn) {
    try {
        return serializerFn();
    }
    catch (err) {
        throw new Err.FailedToSerialize(`Could not serialize message to binary`, err);
    }
}
class ServerRegistry {
    methods = new Map();
    notifications = new Map();
    // eslint-disable-next-line class-methods-use-this
    getImplementation(rpcMessage, map) {
        if (!rpcMessage?.header?.method) {
            throw new UnknownRpcMethod('Header "method" missing from RPC message');
        }
        if (!map.has(rpcMessage.header.method)) {
            throw new UnknownRpcMethod(`RPC Method ${rpcMessage.header.method} is not provided`);
        }
        return map.get(rpcMessage.header.method);
    }
    async handleRequest(rpcMessage, callContext) {
        logger.trace(`Server processing RPC call ${rpcMessage.requestId}`);
        const implementation = this.getImplementation(rpcMessage, this.methods);
        const timeout = implementation.options.timeout;
        return await (0, common_1.promiseTimeout)(timeout, implementation.fn(rpcMessage.body, callContext ?? new ProtoCallContext_1.ProtoCallContext()));
    }
    async handleNotification(rpcMessage, callContext) {
        logger.trace(`Server processing RPC notification ${rpcMessage.requestId}`);
        const implementation = this.getImplementation(rpcMessage, this.notifications);
        const timeout = implementation.options.timeout;
        await (0, common_1.promiseTimeout)(timeout, implementation.fn(rpcMessage.body, callContext ?? new ProtoCallContext_1.ProtoCallContext()));
    }
    registerRpcMethod(requestClass, returnClass, name, fn, opts = {}) {
        const options = parseOptions(opts);
        const method = {
            fn: async (data, callContext) => {
                const request = parseWrapper(() => any_1.Any.unpack(data, requestClass));
                const response = await fn(request, callContext);
                return any_1.Any.pack(response, returnClass);
            },
            options
        };
        this.methods.set(name, method);
    }
    registerRpcNotification(requestClass, name, fn, opts = {}) {
        const options = parseOptions(opts);
        const notification = {
            fn: async (data, callContext) => {
                const request = parseWrapper(() => any_1.Any.unpack(data, requestClass));
                await fn(request, callContext);
            },
            options
        };
        this.notifications.set(name, notification);
    }
}
exports.ServerRegistry = ServerRegistry;
//# sourceMappingURL=ServerRegistry.js.map